import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import IdleTimerContainer from "components/blocks/IdleTimer/IdleTimerContainer";
import useGetRole, { ROLES } from "hooks/useGetRole";
import { sessionDebugLog } from "utils/sessionExpirationUtils";

const PrivatePatientRoutesLayout: React.FC = () => {
  const location = useLocation();
  const userRole = useGetRole.getRole();
  const isImpersonation = useGetRole.isImpersonation();
  const shouldRunSessionTimer =
    isImpersonation ||
    typeof userRole !== "string" ||
    userRole === ROLES.PACIENTE ||
    userRole === ROLES.AUTONOMO;

  useEffect(() => {
    sessionDebugLog("patient route session owner mounted");
    return () => sessionDebugLog("patient route session owner unmounted");
  }, []);

  useEffect(() => {
    sessionDebugLog("patient route session", {
      path: location.pathname,
      userRole,
      isImpersonation,
      timerEnabled: shouldRunSessionTimer,
    });
  }, [location.pathname, userRole, isImpersonation, shouldRunSessionTimer]);

  return (
    <>
      {shouldRunSessionTimer && (
        <IdleTimerContainer isImpersonation={isImpersonation} />
      )}
      <Outlet />
    </>
  );
};

export default PrivatePatientRoutesLayout;